// 排程退藥（醫囑退藥） component

<template lang="pug">
  div
    div.upper-subpanel.row
      progressBar
      div.upper-subpanel--without-progressbar
        scanBarcode(v-if="stage === 'scanBarcode'" v-on:setBarcode="getBarcode")
        ScheduleList(
          v-if="stage === 'ScheduleList'"
          v-on:setSchedule="getSchedule"
          :fireRefetch="fireRefetch"
          :viewMode="'scheduleList'"
          :filterOutZeroAmountMed="true"
        )
        EventTable(v-if="stage === 'selectDrug'" :eventType="eventType" :singleSelection="false" :number2="$store.state.schedule.currentSchedule.id")
        
        MultiFlow(
          v-if="stage === 'startFlow'"
          :startType="'event'"
          :barcodeData="barcodeData"
          :multiProgress="multiProgress"
          :confirmProgress="confirmProgress"
          :actionProgress="actionProgress"
          v-on:setAllConfirmData="getAllConfirmData"
        )

    BottomButtons
      action-button(title="回主畫面" slot="button-1" @click.native="cancel")
      action-button(title="病人列表" slot="button-3" @click.native="stage = 'ScheduleList'" v-if="(stage === 'ScheduleList' || stage === 'scanBarcode') && $store.state.generalSetting.mode === 'nursing'")
      action-button(title="掃描條碼" slot="button-3" @click.native="stage = 'scanBarcode'" v-if="stage === 'ScheduleList' || stage === 'scanBarcode'")
      //- action-button(title="手動退藥" slot="button-3" @click.native="$router.push({ name: 'returnDrug', params: { drugSetMethod: 'manual' } })" v-if="stage === 'ScheduleList' || stage === 'scanBarcode'")
      //- action-button(title="取藥紀錄" slot="button-4" @click.native="$router.push({ name: 'returnDrug', params: { drugSetMethod: 'event' } })" v-if="stage === 'ScheduleList' || stage === 'scanBarcode'")
      //- action-button(title="更新排程" slot="button-7" @click.native="fireRefetch += 1" v-if="stage === 'ScheduleList'")
      action-button(title="開始退藥" slot="button-9" @click.native="startFlow" v-if="stage === 'selectDrug'" :clickable="$store.state.drugInDevice.selectedDrugInDeviceID.length > 0 || $store.state.event.selectedEventId.length > 0")
              
</template>

<script>
import scanBarcode from './flowComp/ScanBarcode';
import progressBar from './flowComp/ProgressBar';
import ScheduleList from './flowComp/ScheduleList';
import EventTable from './flowComp/EventTable';
import MultiFlow from './ReturnDrugFlow/MultiFlow';
import BottomButtons from './common/BottomButtons';
import AppBase from './ComponentBase/AppBase';

export default {
  name: 'ScheduleReturn',
  extends: AppBase,
  components: {
    progressBar,
    ScheduleList,
    MultiFlow,
    BottomButtons,
    EventTable,
    scanBarcode,
  },
  data() {
    return {
      stage: '',
      fireRefetch: 0,
      eventType: 'FETCH',
      barcodeData: '',
    };
  },
  created() {
    if (this.$route.params.stage) {
      this.stage = this.$route.params.stage;
    } else {
      this.stage = 'scanBarcode';
    }
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.actionProgress = this.setupActionWrapProgress();
  },
  mounted() {
    this.$store.commit('SET_CURRENT_STEP', 'selectPatient');
  },
  computed: {
    currentSchedule() {
      return this.$store.getters.currentSchedule;
    },
  },
  methods: {
    setupProgress() {
      const p = [];
      p.push({ en: 'selectPatient', zh: '選擇病人' });
      p.push({ en: 'selectDrug', zh: '選擇使用藥物' });
      p.push({ en: 'selectReason', zh: '選擇理由' });
      p.push({ en: 'setStorage', zh: '退藥數量' });
      if (this.$store.state.user.user.task_privilege.return_drug === false) {
        p.push({ en: 'rxCheck', zh: '覆核動作' });
      }
      if (this.$store.state.generalSetting.check_amount_first) {
        p.push({ en: 'confirmAmount', zh: '確認數量' });
      }
      p.push({ en: 'action', zh: '進行退藥' });
      return p;
    },
    setupMultiProgress() {
      return [
        'confirm',
        'returnEmpty',
        'finish',
      ];
    },
    setupConfirmProgress() {
      const prog = [];
      prog.push('selectReason');
      prog.push('setStorage');
      if (this.$store.state.user.user.task_privilege.return_drug === false) {
        prog.push('rxCheck');
      }
      prog.push('action');
      return prog;
    },
    setupActionWrapProgress() {
      const prog = [];
      if (this.$store.state.generalSetting.check_amount_first) {
        prog.push('confirmAmount');
      }
      prog.push('action');
      prog.push('next');
      return prog;
    },
    cancel() {
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_RETURN' });
      this.$router.push({ name: 'Main' });
    },
    getSchedule() {
      this.stage = 'selectDrug';
    },
    startFlow() {
      this.stage = 'startFlow';
    },
    getAllConfirmData() {
      // refetch data
      this.$store.dispatch('resetAll');
      this.stage = 'scanBarcode';
    },
    getBarcode(scaned) {
      const data = scaned.toString();
      const returnScheduleId = parseInt(data.split(':')[1].split('***')[0], 10);
      this.$store.dispatch('setCurrentScheduleById', returnScheduleId);
      this.stage = 'selectDrug';
    },
  },
  watch: {
    stage(val) {
      if (val === 'selectDrug') {
        this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
      }
      if (val === 'ScheduleList' || val === 'scanBarcode') {
        this.$store.commit('SET_CURRENT_STEP', 'selectPatient');
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// ScheduleReturn.vue?0cfeb116